const SWITCHER_CONFIG_MAP = [
  { name: 'Default', checked: null },
  { name: 'Active', checked: true }
]

export default SWITCHER_CONFIG_MAP
